export * as cards from '@wix/auto_sdk_workflows_cards/schemas';
export * as phases from '@wix/auto_sdk_workflows_phases/schemas';
export * as workflows from '@wix/auto_sdk_workflows_workflows/schemas';
